module.exports = __webpack_public_path__ + "img/card.e1a97c34.svg";